import { styled } from '@linaria/react';
import { colors, fonts, space } from '../../theme/tokens';

export const Wrapper = styled.div<{ $spacing?: 'default' | 'large' }>`
  display: flex;
  align-items: center;
  gap: ${space[3]};
  padding: ${(p) => (p.$spacing === 'large' ? space[6] : space[4])} 0;
`;

export const Line = styled.div`
  flex: 1;
  height: 1px;
  background: ${colors.borderGrey};
`;

export const Text = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  color: ${colors.fontSecondary};
  flex-shrink: 0;
`;
